import "../Challenges.css"
import React, { useState } from "react";
import "../../myProjects/Myprojects.css"
import { FileUploader } from 'react-drag-drop-files';
import api from "views/auth/Api";
import { message } from 'antd';
import { API_BASE_URL } from '../../../../configs/AppConfig';
import { FILES_URL } from '../../../../configs/AppConfig';
import Loader from "components/loader";



const fileTypes = ["JPG", "PNG", "WEBP","JPEG"];


const AddChallange = () => {
  const [img, setImg] = useState(null);
  const [cover, setCover] = useState(null);
  const [cardLoading, setCardLoading] = useState(false);
  const [coverLoading, setCoverLoading] = useState(false);
  console.log("img:", img);
  console.log("cover:", cover);

        const [formInputs , setFormInputs] = useState({
          title:"",
          subject:"",
          grade:"",
          challengeTheme:"",
          designSubmission:"",
          nutshell:"",
          mission:"",
          judgingCriteria:"",
          termsConditions:"",
          videoUrl:"",
        });
    
      // const token = localStorage.getItem('token');
      // const decoded = jwtDecode(token);
      // const id = decoded.id;
      // const role = decoded.role

      const success = () => {
           message.success('Your Challenge careated successfully');
          };
      const errormassage = (massage) => {
           message.error(massage);
          }

    const successPhoto = () => {
           message.success('Your Image uploaded successfully');
          };



  // const [editor] = useState(() => withReact(createEditor()));
  // const [value, setValue] = useState([
  //   {
  //     type: "paragraph",
  //     children: [{ text: "Start typing here..." }],
  //   },
  // ]);
  // console.log("Editor value:", value);

        const isFormValid = formInputs.title.trim() !== '' && formInputs.subject.trim() !== '' && formInputs.grade.trim() !== '' && formInputs.videoUrl.trim() !== '' ;
       
        const handleImgChange = async (img) => {
          setCardLoading(true);
          const formData = new FormData();
          formData.append('img', img);
          console.log('Uploaded file:', img);
           await api.post(`${API_BASE_URL}attachment`,formData, {
                      headers: {
            'Content-Type': 'multipart/form-data',
          },
                    })
                            .then(function (response) {
                                setCardLoading(false);
                                  successPhoto();
                                  setImg(response.data);
                            }).catch(error => {
                              console.log("handlesubmit error for blog get ", error)
                            });
        };

      const handleCoverChange = async (cover) => {
        setCoverLoading(true);
        const formData = new FormData();
          formData.append('img', cover);
          console.log('Uploaded file:', cover);
           await api.post(`${API_BASE_URL}attachment`,formData, {
                      headers: {
            'Content-Type': 'multipart/form-data',
          },
                    })
                            .then(function (response) {
                                setCoverLoading(false);
                                  successPhoto();
                                    setCover(response.data);
                                  // setData(response.data)
                            }).catch(error => {
                              console.log("handlesubmit error for blog get ", error)
                              errormassage(error.response?.data?.message || 'Something went wrong while uploading the image');
                            });

        };

    const handleSubmit = (event) => {
    event.preventDefault();
    // popUp([formInputs.title , formInputs.subject, formInputs.grade, img])
      // addChallange();
      submitForm();
    }

      const submitForm = async () => {      
      if(img && cover)  await api.post(`${API_BASE_URL}challenges`,{
          challengeTitle: formInputs.title,
          subject: formInputs.subject,
          grade: formInputs.grade,
          theme: formInputs.challengeTheme,
          designSubmission: formInputs.designSubmission,
          nutshell: formInputs.nutshell,
          mission: formInputs.mission,
          judgingCriteria: formInputs.judgingCriteria,
          termsConditions: formInputs.termsConditions,
          videoUrl: formInputs.videoUrl,
          img: img? img.id : null,
          cover: cover? cover.id : null,
          })
        .then(function (response) {
                  console.log("handlesubmitffff  ", response.data)
                  success();
                      setFormInputs({
                      title:"",
                      subject:"",
                      grade:"",
                      challengeTheme:"",
                      designSubmission:"",
                      nutshell:"",
                      mission:"",
                      judgingCriteria:"",
                      termsConditions:"",
                      videoUrl:"",
                  })
                  setImg(null);
                  setCover(null);

              // setData(response.data)
        }).catch(error => {
          console.log("handlesubmit error for blog get ", error.response?.data?.message)
          errormassage(error.response?.data?.message || 'Something went wrong');
        });
            
          }
    

  return (
   <form className="addChallenge" onSubmit={handleSubmit}>
    <h2>Add New Challenge</h2>
    <div className="addChallengeFlex">
      <div className="addChallengeLR">
          <div className="addCHInpts">
            {/* <span>Challenge title</span> */}
            <label for="challengeTitle">Challenge title</label>
            <input type="text" className="inputWidth" id="challengeTitle" value={formInputs.title} placeholder="Enter challenge title" 
            onChange={(e) =>setFormInputs({...formInputs, title: e.target.value})}/>
          </div>
            <div className="addCHInpts">
            <label for="gradeLevel">Grade level</label>
            <input type="text" className="inputWidth" id="gradeLevel" value={formInputs.grade} placeholder="Enter grade level"
             onChange={(e) =>setFormInputs({...formInputs, grade: e.target.value})}/>
           </div>
         <div className="addCHInpts">
            <label for="challengeTheme">Challenge theme</label>
            <textarea type="text" className="inputWidth" id="challengeTheme" value={formInputs.challengeTheme} placeholder="Enter Challenge theme"
             onChange={(e) =>setFormInputs({...formInputs, challengeTheme: e.target.value})}/>
           </div>
         <div className="addCHInpts">
            <label for="designGuidelines">Design & Submission guidelines</label>
            <textarea type="text" className="inputWidth" id="designGuidelines" value={formInputs.designSubmission} placeholder="Enter Design & Submission guidelines"
             onChange={(e) =>setFormInputs({...formInputs, designSubmission: e.target.value})}/>
           </div>
          <div className="addCHInpts">
            <label for="nutshell">Nutshell</label>
            <textarea type="text" className="inputWidth" id="nutshell" value={formInputs.nutshell} placeholder="Enter Nutshell"
             onChange={(e) =>setFormInputs({...formInputs, nutshell: e.target.value})}/>
           </div>
       <h4 className="trAttachment"> Card Image </h4>
        <div className="mrAtt">
        <FileUploader handleChange={handleImgChange} name="file" types={fileTypes} />
        <Loader loading={cardLoading} />
           {img && !cardLoading ? <img src={`${FILES_URL}${img.url}`} alt="" style={{ width: '200px', height: '150px', marginTop: '10px' }}/> : null}
        </div>

    {/* // <Slate editor={editor} initialValue={value} onChange={newValue => setValue(newValue)}>
    //   <TextEditor editor={editor} />
    // </Slate> */}
    {/* <EditorWrapper /> */}

         {/* <div className="trAttachmentDev mrAtt">
        <FileUploader handleChange={handleChange} name="file" types={fileTypes} className/>
      {file && <p className="mt-4 text-green-600">File selected: {file.name}</p>}
        </div>
      <div className="trAttachmentDev">
        <FileUploader handleChange={handleChange} name="file" types={fileTypes}  />
      {file && <p className="mt-4 text-green-600">File selected: {file.name}</p>}
        </div>  */}
        </div>
          <div className="addChallengeLR">
          <div className="addCHInpts">
            <label for="subject">Subject</label>
            <input type="text" className="inputWidth" id="subject" value={formInputs.subject} placeholder="Enter subject"
             onChange={(e) =>setFormInputs({...formInputs, subject: e.target.value})}/>
          </div>
     <div className="addCHInpts">
            <label for="mission">Mission</label>
            <textarea type="text" className="inputWidth" id="mission" value={formInputs.mission} placeholder="Enter Mission" 
            onChange={(e) =>setFormInputs({...formInputs, mission: e.target.value})}/>
          </div>
    <div className="addCHInpts">
            <label for="judgingCriteria">Judging criteria</label>
            <textarea type="text" className="inputWidth" id="judgingCriteria" value={formInputs.judgingCriteria} placeholder="Enter Judging Criteria" 
            onChange={(e) =>setFormInputs({...formInputs, judgingCriteria: e.target.value})}/>
          </div>
    <div className="addCHInpts">
            <label for="termsConditions">Terms & Conditions</label>
            <textarea type="text" className="inputWidth" id="termsConditions" value={formInputs.termsConditions} placeholder="Enter Terms & Conditions" 
            onChange={(e) =>setFormInputs({...formInputs, termsConditions: e.target.value})}/>
          </div>
    <div className="addCHInpts">
            <label for="termsConditions">Video Url</label>
            <textarea type="text" className="inputWidth" id="videoUrl" value={formInputs.videoUrl} placeholder="Enter Video Url" 
            onChange={(e) =>setFormInputs({...formInputs, videoUrl: e.target.value})}/>
          </div>
       <h4 className="trAttachment"> Cover Image </h4>
        <div className=" mrAtt">
        <FileUploader handleChange={handleCoverChange} name="file" types={fileTypes} />
        <Loader loading={coverLoading} />
     {cover && !coverLoading ? <img src={`${FILES_URL}${cover.url}`} alt="" style={{ width: '200px', height: '150px', marginTop: '10px' }}/> : null}
        </div>

    </div>   

        </div>
        <div style={{textAlign:"center"}}>
        <button type="submit" disabled={!isFormValid} className="add-Challenge">Publish</button>
        </div>
       </form> 
  );
};

export default AddChallange;
